import { render, staticRenderFns } from "./ProductName.vue?vue&type=template&id=6769be08&scoped=true&"
import script from "./ProductName.vue?vue&type=script&lang=ts&"
export * from "./ProductName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6769be08",
  null
  
)

export default component.exports